import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Check } from 'react-feather';
import { Button, Popup } from 'components/quashed';
import { selectUser } from 'selectors';
import styles from '../styles/DashboardPopup.module.scss';
import { UpdateUser } from 'actions';

const DashboardPopup = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    dispatch(UpdateUser(R.assoc('showDashboardWalkthrough', false, user)));
  };

  return (
    <Popup
      className={styles.popup}
      closeOnDimmerClick={false}
      open={open}
      showLogo
      onClose={handleClose}
    >
      <h3>Quashed Insurance Dashboard ✨</h3>
      <p>
        Finally, you can track and manage all your insurance policies in one
        place!
      </p>
      <img
        alt="Dashboard"
        src={`${MARKETING_SITE_URL}/images/onboarding/laptop-with-mobile.webp`}
      />

      <div className={styles.item}>
        <Check size={16} strokeWidth={4} /> Find out total insurance spend
      </div>
      <div className={styles.item}>
        <Check size={16} strokeWidth={4} /> Store all policies in one place
      </div>
      <div className={styles.item}>
        <Check size={16} strokeWidth={4} /> Get timely prompts to shop and save
      </div>

      <Button className={styles.button} text="Continue" onClick={handleClose} />
    </Popup>
  );
};

export default DashboardPopup;
